import { Link } from 'react-router-dom';
import { Compass } from '@phosphor-icons/react';

import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/common/EmptyState';
import pt from '../locales/pt';

export function NotFound() {
  return (
    <EmptyState
      icon={Compass}
      title={pt.common.notFoundTitle}
      description={pt.common.notFoundBody}
      action={
        <Button asChild>
          <Link to="/">{pt.common.back}</Link>
        </Button>
      }
    />
  );
}
